import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../../app.config';
import { catchErrorLogRet, mapRetrieve } from '../../common/rest.operators';

import { PerformerDto } from './model/performer-dto.model';
import { PerformerHistoryDto } from './model/performer-history-dto.model';

@Injectable()
export class Mi2Service {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrieveDirectReports(userId: number): Observable<PerformerDto> {
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.SCORECARD}/mi2/${userId}/direct-reports`,
            )
            .pipe(mapRetrieve(), catchErrorLogRet({}));
    }

    retrieveDirectReportsHistory(
        managerId: number,
        userId: number,
    ): Observable<PerformerHistoryDto> {
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.SCORECARD}/mi2/${userId}/direct-reports/${userId}/history`,
            )
            .pipe(mapRetrieve(), catchErrorLogRet({}));
    }
}
